import type { LiveSearchAGGQueryVariables } from '../API/AGGSearchTypes.ts';
import type { KeyableInterface } from '../types.ts';

// eslint-disable-next-line import/no-cycle
import { createAggFilters } from './aggFilters.ts';

type getQueryVariablesForAggSearchArgs = {
	searchInput: string;
	config: KeyableInterface;
	currentSpaceKey: string | undefined;
	confluenceInstance: string;
};

export const CONFLUENCE_EXPERIENCE = 'confluence.liveSearchMacro';
export const CONTEXT_PATH = '/wiki';
export const RESULT_MAX = 5;
export const LABEL_FILTER_SEPARATOR = ',';

// default entities for LSM appear to be different than AS and QS
export const DEFAULT_ENTITIES = [
	'ati:cloud:confluence:page',
	'ati:cloud:confluence:blogpost',
	'ati:cloud:confluence:space',
	'ati:cloud:confluence:comment',
	'ati:cloud:confluence:whiteboard',
	'ati:cloud:confluence:database',
	'ati:cloud:confluence:embed',
];

export enum ConfluenceATIs {
	PAGE = 'ati:cloud:confluence:page',
	BLOG = 'ati:cloud:confluence:blogpost',
	SPACE = 'ati:cloud:confluence:space',
	COMMENT = 'ati:cloud:confluence:comment',
	WHITEBOARD = 'ati:cloud:confluence:whiteboard',
	DATABASE = 'ati:cloud:confluence:database',
	EMBED = 'ati:cloud:confluence:embed',
}

export const getQueryVariablesForAGGSearch = ({
	searchInput,
	config,
	currentSpaceKey,
	confluenceInstance,
}: getQueryVariablesForAggSearchArgs): {
	variables: LiveSearchAGGQueryVariables;
} => {
	const { type, spaceKey, labels } = config;
	return {
		variables: {
			experience: CONFLUENCE_EXPERIENCE,
			query: searchInput,
			first: RESULT_MAX,
			filters: {
				entities: getEntities(type),
				locations: [confluenceInstance],
				confluenceFilters: createAggFilters(spaceKey, currentSpaceKey, labels),
			},
		},
	};
};

export const getEntities = (type: string | undefined) => {
	let entities;
	switch (type) {
		case 'page':
			entities = [ConfluenceATIs.PAGE];
			break;
		case 'blogpost':
			entities = [ConfluenceATIs.BLOG];
			break;
		case 'spacedesc':
			entities = [ConfluenceATIs.SPACE];
			break;
		case 'comment':
			entities = [ConfluenceATIs.COMMENT];
			break;
		case 'whiteboard':
			entities = [ConfluenceATIs.WHITEBOARD];
			break;
		case 'database':
			entities = [ConfluenceATIs.DATABASE];
			break;
		case 'embed':
			entities = [ConfluenceATIs.EMBED];
			break;
		default:
			entities = DEFAULT_ENTITIES;
	}
	return entities;
};
